/**
 * Yandex Map API v3
 * Wrapping from Vegas
 *
 */
import {findContainer, getDataAttributes, getSystemTheme, mergeDeepObject, setParamArray} from "./_util";

const VGMap3 = {
	isDebug: false,

	breakpoints: {
		xs: 0,
		sm: 640,
		md: 767,
		lg: 991,
		xl: 1199,
		xxl: 1399,
		xxxl: 1599
	},

	init: async function (map, arg = {}) {
		let isYaMaps = true;
		try {
			if (ymaps3) isYaMaps = true;
		} catch (e) {
			isYaMaps = false;
		}

		if (!isYaMaps) {
			VGLog("error", ['Не возможно запустить сервис API Яндекс.Карт!']);
			return false;
		}

		if (!map) {
			VGLog("error", ['Товарищ! Первый параметр не должен быть пустым!']);
			return false;
		}

		let params = {
			controls: ['zoom', 'geolocation'],
			zoom: 15,
			marker: {
				type: 'default',
				color: App.themeColor,
				custom: {}
			},
			offset: {
				x: [0],
				y: [0]
			},
			sizes: {
				width: [],
				height: []
			},
			theme: "light",
			behaviors: ['drag', 'pinchZoom', 'mouseTilt'],
			bounds: false
		}, dataParams = {};

		if (typeof map === 'string') {
			params.map = findContainer('#' + map);
			params.id = map;

			if (params.map) dataParams = getDataAttributes(params.map, true);
		} else if (typeof map === 'object') {
			let target = map.getAttribute('id') || null;

			if (!target) {
				VGLog("error", ["Мон Синьор! Путь к карте не найден"]);
				return false;
			}

			params.id = target;
			params.map = findContainer('#' + target);
			dataParams = getDataAttributes(map, true);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.map) {
			VGLog("error", ["Сударь! А где, собственно, карта?"]);
			return false;
		}

		params = mergeDeepObject(params, arg, dataParams);

		if ('vg-map' in params) {
			this.isGlobalInit = true;
			delete params['vg-map'];
		}

		/* размер карты */
		if ('height' in params) {
			params.sizes.height = setParamArray(params.height, true);
			delete params['height'];
		}

		if ('width' in params) {
			params.sizes.width = setParamArray(params.width, true);
			delete params['width'];
		}

		/* смещение карты */
		if ('offset-y' in params) {
			params.offset.y = setParamArray(params['offset-y'], true);
			delete params['offset-y'];
		}

		if ('offset-x' in params) {
			params.offset.x = setParamArray(params['offset-x'], true);
			delete params['offset-x'];
		}

		/* Тема: светлая, темная или как в системе. По умолчанию: светлая */
		if ('theme' in params) {
			if (params.theme === 'system') {
				params.theme = getSystemTheme();
			}
		}

		/* Zoom */
		if ('zoom' in params) {
			params.zoom = parseInt(params['zoom']);
		}

		/* тип маркера */
		if ('marker-custom' in params) {
			params.marker.type = 'custom';

			if (typeof params['marker-custom'] === 'string') {
				params.marker.custom = JSON.parse(params['marker-custom']);
			} else {
				params.marker.custom = params['marker-custom'];
			}

			delete params['marker-custom']
		}

		/* Возвращает массив с координатами одной точки */
		function getCoordinate(params) {
			let coordinate = [];

			if ((!params.lat && !params.lon) && ('points' in params)) {
				if (params.points.length && !(params.lat && params.lon)) {
					let points;

					if (typeof params.points === 'string') {
						points = JSON.parse(params.points);
					} else {
						points = params.points;
					}

					for (let i = 0; i < points.length; i++) {
						if (('lat' in points[i]) && ('lon' in points[i])) {
							if (i === 0) {
								coordinate.push(points[i].lon)
								coordinate.push(points[i].lat)
							}
						}
					}
				}
			} else if (params.lat && params.lon) {
				coordinate.push(parseFloat(params.lon));
				coordinate.push(parseFloat(params.lat));

				delete params.lon;
				delete params.lat;
			}

			return coordinate;
		}

		params.coordinate = getCoordinate(params);

		if (!params.coordinate.length) {
			VGLog("error", ["Ахпер! Гдэ координаты, для карты #" + params.id + "!"]);
			return false;
		}

		/* Смотрим, что собрали */
		if (this.isDebug) {
			console.log(params);
		}

		/* Поехали! */
		await VGMap3.Map.run(params);
	},

	Map: {
		run: async function (params) {
			let map;

			/* Устанавливаем размер карты */
			VGMap3.Map.size(params)

			/* ожидание загрузки модулей */
			await ymaps3.ready;
			const {
				YMap,
				YMapDefaultSchemeLayer,
				YMapControls,
				YMapDefaultFeaturesLayer,
				YMapMarker
			} = ymaps3;

			/* Создание объекта карты */
			const Location = {center: params.coordinate, zoom: params.zoom}
			map = new YMap(params.map, {
				location: Location,
				behaviors: params.behaviors
			});
			map.setMode('vector');

			/* Добавление слоев на карту */
			map.addChild(new YMapDefaultSchemeLayer({
				theme: params.theme
			}));
			map.addChild(new YMapDefaultFeaturesLayer({id: 'features'}));

			/* Добавляем маркер */
			await VGMap3.Marker.set(map, params, YMapMarker)

			/* Добавление элементов управления на карту */
			await VGMap3.Map.controls(params, map, YMapControls);

			/* Сдвиг карты. TODO не работает */
			VGMap3.Map.offset(map, params);
		},

		controls: async function (params, map, mapControls) {
			/* Импорт модулей для элементов управления на карте */

			const {
				YMapZoomControl,
				YMapGeolocationControl
			} = await ymaps3.import('@yandex/ymaps3-controls@0.0.1');

			if (params.controls.includes('zoom')) {
				map.addChild(new mapControls({position: 'right'})
					.addChild(new YMapZoomControl({
						easing: 'linear'
					}))
				);
			}

			if (params.controls.includes('geolocation')) {
				map.addChild(new mapControls({position: 'top right'})
					.addChild(new YMapGeolocationControl({}))
				);
			}
		},

		offset: function (map, params) {
			let offsetX  = params.offset.x,
				offsetY  = params.offset.y;

			VGMap3.Map.setBreakpoints(setOffset);

			function setOffset(index) {
				let x = offsetX[index],
					y = offsetY[index];

				if (x === undefined) {
					x = offsetX[offsetX.length - 1];
				}

				if (y === undefined) {
					y = offsetY[offsetY.length - 1];
				}

				if (VGMap3.isDebug) {
					console.log('offset: x-' + x + ', y-' + y)
				}

				/*let position = map.getGlobalPixelCenter();
				map.setGlobalPixelCenter([position[0] - x, position[1] - y]);*/
			}
		},

		size: function (params) {
			// todo тут где то есть jquery
			const $map = $(params.map);

			setParamSizes('height', $map.height());
			//setParamSizes('width', $map.width());

			let width = params.sizes.width,
				height = params.sizes.height;

			VGMap3.Map.setBreakpoints(setSizes);
			function setSizes(index) {
				let _width = width[index],
					_height = height[index];

				if (_width === undefined) {
					_width = width[width.length - 1];
				}

				if (_height === undefined) {
					_height = height[height.length - 1];
				}

				$map.css('height', _height);
				$map.css('width', _width);
			}

			function setParamSizes(side, value) {
				if (side in params.sizes) {
					let aSide = params.sizes[side]

					if (!aSide.length) {
						if (value === 0) {
							params.sizes[side].push(VGMap3.size[side]);
						} else {
							params.sizes[side].push(value);
						}
					}
				}
			}
		},

		setBreakpoints: function (func, width = null) {
			if (width) {
				let _breakpoints = Object.keys(VGMap3.breakpoints);

				for (let i = 0; i < _breakpoints.length; i++) {
					if (width <= VGMap3.breakpoints[_breakpoints[i]]) {
						func(i)
					}
				}
			} else {
				if (window.innerWidth <= VGMap3.breakpoints['sm']) {
					func(0);
				} else if (window.innerWidth >= VGMap3.breakpoints['sm'] && window.innerWidth <= VGMap3.breakpoints['md']) {
					func(1);
				} else if (window.innerWidth >= VGMap3.breakpoints['md'] && window.innerWidth <= VGMap3.breakpoints['lg']) {
					func(2);
				} else if (window.innerWidth >= VGMap3.breakpoints['lg'] && window.innerWidth <= VGMap3.breakpoints['xl']) {
					func(3);
				} else if (window.innerWidth >= VGMap3.breakpoints['xl'] && window.innerWidth <= VGMap3.breakpoints['xxl']) {
					func(4);
				} else if (window.innerWidth >= VGMap3.breakpoints['xxl']) {
					func(5);
				}
			}
		}
	},

	Marker: {
		set: async function (map, params, mapMarker) {
			let marker = {};

			const {YMapDefaultMarker} = await ymaps3.import('@yandex/ymaps3-markers@0.0.1');

			if (params.marker.type === 'default' && !('points' in params)) {
				marker = VGMap3.Marker.default(params.marker, params.coordinate);
				map.addChild(new YMapDefaultMarker(marker))
			} else if (params.marker.type === 'custom' && !('points' in params)) {
				marker = VGMap3.Marker.custom(params.marker.custom);
				map.addChild(new mapMarker({coordinates: params.coordinate}, marker));
			}

			if ('points' in params) {
				let points;

				if (typeof params.points === 'string') {
					points = JSON.parse(params.points);
				} else {
					points = params.points;
				}

				if (params.marker.type === 'default') {
					let coordinates = []

					for (const point of points) {
						marker = VGMap3.Marker.default({
							color: point.color,
							title: point.title,
							subtitle: point.subtitle,
						}, [point.lon, point.lat])
						map.addChild(new YMapDefaultMarker(marker));

						coordinates.push([point.lon, point.lat])
					}

					if (params.bounds) {
						// TODO криво работает
						map.setLocation({
							bounds: coordinates
						})
					}
				} else if (params.marker.type === 'custom') {
					for (const point of points) {
						marker = VGMap3.Marker.custom(point);
						map.addChild(new mapMarker({coordinates: params.coordinate}, marker));
					}
				}
			}
		},

		default: function (mark, coordinates) {
			return {
				coordinates: coordinates,
				color: mark.color,
				title: mark.title,
				subtitle: mark.subtitle
			};
		},

		custom: function (mark) {
			const el = document.createElement('img');
			el.className = mark.class;
			el.src = mark.src;
			el.style.transform = 'translate(-50%,calc(-50% - 24px))';

			return el;
		}
	},
};

export default VGMap3;
